(function () {
  Flint.file('views/navLink.js', function (require) {
    Flint.view('NavLink', function (view, on, $) {
      var context = initContext(view, {
        colors: atom(),
        route: atom()
      });

      var pro = initPro(view, {
        to: atom(),
        target: atom()
      });

      var selected = derivation(function () {
        return M.routeIsActive(pro.to.get());
      });view.render(function () {
        return view.el(
          ['Link', 1],
          { to: pro.to.get(), target: pro.target.get(), style: IMap({
              color: selected.get() ? context.colors.get().accent : 'black'
            }).merge(pro.style.get().get('link')).toJS() },
          pro.children.get()
        );
      });
    });
  })
})();
//# sourceMappingURL=navLink.js.map
